<template>
  <div class="community">
    <Banner page="community"/>
    <ProjectRankList/>
    <UserRankList/>
  </div>
</template>

<script>

import Banner from "../../components/Banner";
import ProjectRankList from "@/components/community/ProjectRankList"
import UserRankList from "@/components/community/UserRankList"
export default {
  name: "Community",
  components: {
    Banner,
    ProjectRankList,
    UserRankList
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style land="less" scoped>
</style>